import React, { Component } from 'react';
import getSearchQueryParams from './getSearchQueryParams';
import PropTypes from 'prop-types';
import LoadingSpinner from '../../loading-spinner/LoadingSpinner'; // Should stop using ../../ here
import processExcerptToHtml from './processExcerptToHtml';
import filterHostNameForApi from './lib/filterHostNameForApi';
import './results-style.css'; //Is used. Do not remove.

export default class SearchResultsController extends Component {
  constructor(props) {
    super(props);
    this.state = { results: [], loading: true, searchText: '' };
  }

  componentDidMount() {
    const self = this;
    const searchText = getSearchQueryParams().q;
    if (searchText === null) {
      self.setState({ results: [], loading: false, searchText: searchText });
    }
    fetch(
      this.props.apiUrl +
        '?hostname=' +
        encodeURIComponent(filterHostNameForApi(window.location.hostname)) +
        '&q=' +
        encodeURIComponent(searchText),
      { credentials: 'same-origin' }
    )
      .then((resp) => resp.json())
      .then(function (data) {
        if (data) {
          self.setState({
            results: data,
            loading: false,
            searchText: searchText,
          });
        } else {
          self.setState({
            results: [],
            loading: false,
            searchText: searchText,
          });
        }
      });
  }

  render() {
    console.log(this?.state?.searchText);
    return (
      <div>
        {this.state.loading && <LoadingSpinner />}
        {!this.state.loading && (
          <div>
            {this.state.results.length === 0 && (
              <div className='zrcms-search-no-results'>
                {this.props.noResultsText}
              </div>
            )}
            {this.state.results.map((result, index) => (
              <div key={index} className='zrcms-search-result'>
                <a className='zrcms-search-result-title' href={result.url}>
                  {result.title}
                </a>
                <div className='zrcms-search-result-url'>{result.url}</div>
                <div
                  className='zrcms-search-result-excerpt'
                  dangerouslySetInnerHTML={processExcerptToHtml(
                    result.excerpt,
                    this.state.searchText ? this.state.searchText : ''
                  )}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  static propTypes = {
    noResultsText: PropTypes.string,
    apiUrl: PropTypes.string,
  };

  static defaultProps = {
    noResultsText: 'No results found.',
    apiUrl: '/api/v2/search-rat/search',
  };
}
